import BrandLogo from '../../../assets/icons/BrandLogo';

import { AwfulSmile, BadSmile, OkSmile, GoodSmile, GreatSmile } from "../../../assets/icons/smiles/_index.js";

import { QualityCircle, QualityBad, QualityGood } from '../../../assets/icons/quality/_index.js';

//Actions
import {
  ArrowDown, ArrowLeft, ArrowRight, ArrowUp, ChevronDown, ChevronUp, ChevronRight, ChevronLeft,
  Plus, Less, Close, Check, Download, Collapse, CollapseOpen, Expand, Search, Visibillity, VisibillityOff, Lock, Unlock,
  User, UserGroup, Filter, FilterOn, Menu, MenuDot, List, Information, Help, Doc, Share, Euro, Global,
  Favorite, FavoriteFill, Settings, Layers, Drag, Trash, SortDown, SortUp, Edit, Pin, Attach, Customize, Clipboard,
  Lamp, ZoomIn, ZoomOut, HoldingHands, Upload
} from "../../../assets/icons/actions/_index.js";

//Alert
import { Error, Bell, Alert } from "../../../assets/icons/alerts/_index.js";

//Communications
import { Mail, Phone, Message, MobileSignal, Router, HackerWater, HackerPower, Mobile } from "../../../assets/icons/communication/_index.js";

//Devices
import { Ac, Fan, Hvac } from "../../../assets/icons/devices/_index.js";

//Media
import { SoundOn } from "../../../assets/icons/media/_index.js";

//Medical
import { Virus, Medical } from "../../../assets/icons/medical/_index.js";

//Navigation
import { Marker, Directions, PinMap, Localization, ZoomFit, Gas, GasStation } from "../../../assets/icons/navigation/_index.js";

//Time
import { Clock, Calendar } from "../../../assets/icons/time/_index.js";

//Transportation
import { Transports, Subway, Bus, Train, BicycleFront, BicycleSide, Car, Walk, CarWalk, Parking, TrafficLight } from "../../../assets/icons/transportation/_index.js";

//Weather
import { Clouds, Clear, Rain, WaterDrop, Bolt, BoltOff, Temperature, Windy, Emissions } from "../../../assets/icons/weather/_index.js";

//Places
import { Building, Environment, Gym, Infrastructure } from "../../../assets/icons/places/_index.js";

export {
  BrandLogo,

  AwfulSmile, BadSmile, OkSmile, GoodSmile, GreatSmile,

  QualityCircle,
  QualityBad,
  QualityGood,

  //Actions
  ArrowDown, ArrowUp, ArrowRight, ArrowLeft,
  ChevronDown, ChevronUp, ChevronRight, ChevronLeft,
  Plus, Less,
  Close, Check,
  Download,
  Collapse, CollapseOpen, Expand,
  Search,
  Visibillity, VisibillityOff,
  Lock, Unlock,
  User, UserGroup,
  Filter, FilterOn,
  Menu, MenuDot,
  List,
  Information, Help,
  Doc, Share,
  Euro,
  Global,
  Favorite, FavoriteFill,
  Settings,
  Layers,
  Drag,
  Trash,
  SortDown,
  SortUp,
  Edit, Pin, Attach, Customize, Clipboard,
  Lamp,
  ZoomIn, ZoomOut,
  HoldingHands, Upload,

  //Alerts
  Error, Bell, Alert,

  //Communications
  Mail, Phone, Message, MobileSignal, Router,
  HackerWater, HackerPower, Mobile,

  //Devices
  Ac, Fan, Hvac,

  //Media
  SoundOn,

  //Medical
  Virus, Medical,

  //Navigation
  Marker, Directions, PinMap, Localization, ZoomFit, Gas, GasStation,

  //Time
  Clock, Calendar,

  //Transportation
  Transports, Subway, Bus, Train, BicycleFront, BicycleSide, Car, Walk, CarWalk, Parking, TrafficLight,

  //Weather
  Clouds, Clear, Rain, WaterDrop, Bolt, BoltOff, Temperature, Windy, Emissions,

  //Weather
  Building, Environment, Gym, Infrastructure
} 